export default {
  timeout: 10 * 1000,
  host: 'https://fcapi.wanjiajjl.com', // 线上
//   host: 'http://uat-heiliao-api.qzappapia456.com', // uat
  webKey: 'luckygogointch-intech',
  endPoint: 'H5'
};
